import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import ACKDemosPage from './pages/ACKDemosPage';
import BeautySalonDemo from './pages/BeautySalonDemo';
import HVACDemo from './pages/HVACDemo';
import DemoPage from './pages/DemoPage';
import BookingPage from './pages/BookingPage';
import BookingSuccessPage from './pages/BookingSuccessPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import '@/index.css';
import './App.css';

function App() {
  useEffect(() => {
    // Remove Emergent badge
    const removeBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) {
        badge.remove();
      }
      // Remove any other badges
      const badges = document.querySelectorAll('a[href*="emergent"]');
      badges.forEach(b => b.remove());
    };
    
    // Run immediately
    removeBadge();
    
    // Run again after a delay
    setTimeout(removeBadge, 100);
    setTimeout(removeBadge, 500);
    setTimeout(removeBadge, 1000);
    
    // Observe DOM changes
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* ACK Demos - Main Public Site */}
          <Route path="/" element={<ACKDemosPage />} />
          
          {/* Demo Showcase - Organized under /demos */}
          <Route path="/demos/beauty-salon" element={<BeautySalonDemo />} />
          <Route path="/demos/beauty-salon/booking" element={<BookingPage />} />
          <Route path="/demos/beauty-salon/booking-success" element={<BookingSuccessPage />} />
          <Route path="/demos/beauty-salon/admin" element={<AdminLoginPage />} />
          <Route path="/demos/beauty-salon/admin/dashboard" element={<AdminDashboardPage />} />
          
          <Route path="/demos/hvac-contractor" element={<HVACDemo />} />
          
          {/* Demo Overview Page */}
          <Route path="/demo" element={<DemoPage />} />
          
          {/* Legacy routes - redirect to new structure */}
          <Route path="/beauty-demo" element={<Navigate to="/demos/beauty-salon" replace />} />
          <Route path="/beauty-demo/*" element={<Navigate to="/demos/beauty-salon" replace />} />
          <Route path="/ivs-demo" element={<Navigate to="/demos/beauty-salon" replace />} />
          <Route path="/ivs-demo/*" element={<Navigate to="/demos/beauty-salon" replace />} />
          <Route path="/booking" element={<Navigate to="/demos/beauty-salon/booking" replace />} />
          <Route path="/booking-success" element={<Navigate to="/demos/beauty-salon/booking-success" replace />} />
          <Route path="/admin" element={<Navigate to="/demos/beauty-salon/admin" replace />} />
          <Route path="/admin/dashboard" element={<Navigate to="/demos/beauty-salon/admin/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </>
  );
}

export default App;
